import { kanjiVariantMap } from './kanjiVariantMap';

// 旧字体を新字体に 1 字ずつ置き換える。対応表は 1 字 → 1 字 (BMP 内) のため文字数は変わらない。
export const toNew = (str) => {
  let out = '';
  for (const ch of String(str ?? '')) {
    out += kanjiVariantMap[ch] ?? ch;
  }
  return out;
};
